import React from 'react';
import { withPlaceholder } from 'HOC';
import { PortfolioAssetsType } from 'services/requests';
import { useGetAllAssets } from 'hooks/api/portfolio';
import { AssetsColumnsType, mapData } from './UserAssetsTable.columns';
import RenderAssetsTable from './components/RenderAssetsTable';

const RenderTablewithPlaceholders = withPlaceholder(RenderAssetsTable);

const defaultColumns: AssetsColumnsType[] = [
  'currency',
  'usdAmount',
  'cryptoAmount',
  'estCostBasis',
  'priceChange',
  'usdPrice',
];

type Props = {
  columns?: AssetsColumnsType[];
  assetsData?: PortfolioAssetsType;
  portfolioAssetsLoading: boolean;
  isError: boolean;
  refetch: () => void;
  isRefetching: boolean;
};

const UserAssetsTable: React.FC<Props> = ({
  columns = defaultColumns,
  assetsData,
  portfolioAssetsLoading,
  isError,
  refetch,
  isRefetching,
}) => {
  const { isLoading: allAssetsLoading } = useGetAllAssets();

  const isLoading = portfolioAssetsLoading || allAssetsLoading;

  const items = mapData(assetsData?.items);

  const onAssetClick = () => {};

  return (
    <RenderTablewithPlaceholders
      columns={columns}
      assetsListData={assetsData}
      items={items}
      onAssetClick={onAssetClick}
      refetch={refetch}
      isRefetching={isRefetching}
      isLoading={isLoading}
      isError={isError}
      isData={!!items && items?.length !== 0}
    />
  );
};

export default UserAssetsTable;
